import React, { useState, useEffect } from 'react';
import { getTitleFromUrl } from '../src/Constants/StaticPages';
import { getFilteredCategoryContent } from '../src/Utils/helper';
import { data_stretch_marks } from '../src/components/StoreCategoryPage/PerfectDiaperForBaby/constant';
import StoreHomeMainComponent from '../src/components/StoreHomePage/StoreHomeMainComponent';
import { getProductCategorySitemapData } from '../src/datafetchers/ProductCategory';
import {
  getCategoryDataForStoreCategoriesWeb,
  storeDataFetcher,
} from '../src/datafetchers/Store';
import NewFooter from '../src/components/HomePage/NewFooter';
import WebTab from '../src/components/WebTabStructure/WebTab';
import { getUserIsLoggedIn } from '../src/Utils/helper';
import { fromSkip } from '../src/components/LoginModule/NewLoginModule/common';
import { NewLoginContainer } from '../src/components/LoginModule/NewLoginModule/styled';
import NewLoginScreen from '../src/components/LoginModule/NewLoginModule/NewLoginScreen';
import Cookies from 'js-cookie';
import NewHeader from '../src/components/HomePage/NewHeader';
import OfferStripHeader from '../src/components/ArticlePage/OfferStripHeader';
import MyAccount from '../src/components/MyAccountPage/MyAccount';
import AllCategories from '../src/components/AllCategoriesPage/AllCategories';
import Community from '../src/components/CommunityPageTab/Community';
import { SkeletonBox } from '../src/components/Product/Skeleton/styled';
import GlobalStyle from '../src/styles/globalStylesV2';
import { getWebUserType } from '../src/Utils/getWebUserType';
const KwikPassSsoTooltip = dynamic(
  () => import('../src/components/KwikPassSsoTooltip'),
  {
    ssr: false,
  },
);
import { checkEligibilityForSsoTooltip } from '../src/Utils/commonUtils';
import dynamic from 'next/dynamic';

export async function getStaticProps(context) {
  const data = await storeDataFetcher({
    skip: 0,
    limit: 10,
    lang: 'en',
    inApp: false,
    desktopView: true,
    key: 'store',
    userType: 'A',
  });
  const babyCareCategories = await getCategoryDataForStoreCategoriesWeb();
  const sitemapData = await getProductCategorySitemapData();
  const catUrls = sitemapData?.data?.map((data) => data.url);
  return {
    props: {
      storeHomeStaticData: data?.data?.cards,
      categoryData: getFilteredCategoryContent(data?.data?.categories),
      categoryCardsData: getFilteredCategoryContent(babyCareCategories?.data),
      catUrls: catUrls,
      brand: 'store',
    },
    revalidate: 300,
  };
}

function Brand(props) {
  const [activeTab, setActiveTab] = useState('1');
  const [changeCartCount, setChangeCartCount] = useState();
  const [isLoggedIn, setIsLoggedIn] = useState(getUserIsLoggedIn());
  const [userType, setUserType] = useState('');
  const [showSsoTooltipDot, setShowSsoTooltipDot] = useState(false);
  const [showSsoTooltip, setShowSsoTooltip] = useState(false);
  const { storeHomeStaticData, categoryData, catUrls, categoryCardsData } =
    props;
  const [loginPopUp, setLoginPopUp] = useState(false);

  storeHomeStaticData?.data?.cards?.items.splice(3, 0, data_stretch_marks);
  let seoFootnoteData;
  const storeItems = storeHomeStaticData?.items;
  for (let i = 0; i < storeItems.length; i++) {
    if (storeItems[i]?.itemType == 'SEO_FOOTNOTE') {
      seoFootnoteData = storeItems[i];
      break;
    }
  }
  let catDataSEO = '<h2><strong>Product Categories</strong></h2>';
  catDataSEO += catUrls?.reduce((acc, curr) => {
    acc += `<a href=${curr}>${getTitleFromUrl(curr, true)}</a>  |  `;
    return acc;
  }, '<p>');
  catDataSEO += '</p>';
  if (
    seoFootnoteData.htmlText &&
    !seoFootnoteData.htmlText.includes('Product Categories')
  )
    seoFootnoteData.htmlText += catDataSEO;

  const showRedirecting = isLoggedIn || Cookies.get(fromSkip);

  useEffect(() => {
    const savedTab = sessionStorage.getItem('selectedBottomTab');
    if (savedTab) {
      setActiveTab(savedTab);
    }
    const webUserType = getWebUserType();
    setUserType(webUserType);
  }, []);

  useEffect(() => {
    setIsLoggedIn(getUserIsLoggedIn());
  }, [activeTab]);

  const handleLoginSuccess = () => {
    setIsLoggedIn(true);
    setActiveTab('4');
  };

  const renderContent = () => {
    switch (activeTab) {
      case '1':
        return (
          <StoreHomeMainComponent
            metaTitleHome={storeHomeStaticData?.metaTitle}
            metaDescHome={storeHomeStaticData?.metaDescription}
            categoryData={categoryData}
            brand={'store'}
            seoFootnoteData={seoFootnoteData}
            storeData={storeHomeStaticData}
            categoryCardsData={categoryCardsData}
            skipHeader={true}
          />
        );
      case '2':
        return <AllCategories />;
      case '3':
        return <Community />;
      case '4':
        return getUserIsLoggedIn() ? (
          <MyAccount />
        ) : (
          <NewLoginContainer loggedIn={showRedirecting}>
            <NewLoginScreen onLoginSuccess={handleLoginSuccess} />
          </NewLoginContainer>
        );
      default:
        return null;
    }
  };

  const showJoyfulDaysMarquee = () => {
    const currentDate = new Date();
    const year = currentDate.getFullYear();
    const month = currentDate.getMonth();
    const day = currentDate.getDate();
    return year === 2025 && month === 5 && (day === 29 || day === 30);
  };

  const openLoginPopUp = () => {
    setLoginPopUp(true);
  };

  useEffect(() => {
    if (!getUserIsLoggedIn() && (activeTab == '1' || activeTab == '2')) {
      const showKwikPassSsoTooltip = checkEligibilityForSsoTooltip();
      setShowSsoTooltip(showKwikPassSsoTooltip);
    } else {
      setShowSsoTooltip(false);
    }
  }, [getUserIsLoggedIn(), activeTab]);

  useEffect(() => {
    if (getUserIsLoggedIn() || !checkEligibilityForSsoTooltip()) {
      setShowSsoTooltip(false);
      return;
    }
    let lastScrollY = window.scrollY;

    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      if (currentScrollY > lastScrollY && currentScrollY > 100) {
        if (showSsoTooltip) {
          setShowSsoTooltipDot(true);
        }
        setShowSsoTooltip(false);
      } else if (currentScrollY < lastScrollY || currentScrollY <= 50) {
        setShowSsoTooltip(true);
        setShowSsoTooltipDot(false);
      }

      lastScrollY = currentScrollY;
    };

    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [showSsoTooltip]);

  return (
    <>
      <NewHeader
        showOldSubHeader={true}
        categoryData={categoryData}
        addedToCart={changeCartCount}
        showCart={true}
        showTrackOrder={true}
        setAddedToCart={setChangeCartCount}
        store={true}
        sticky={true}
        showSsoTooltipDot={showSsoTooltipDot}
        loginPopUp={loginPopUp}
        setLoginPopUp={setLoginPopUp}
      />
      {showJoyfulDaysMarquee() ? (
        <OfferStripHeader
          showHeader={true}
          sticky={true}
          marqueeTextArray={[
            '🎉 Mylo JoyFul Days are LIVE!',
            'Grab 15% OFF + ₹120 Cashback on every Purchase',
            '💰Use Code: CASHBACK120',
            '🔥 Shop Now & Save Big!',
          ]}
          redirectionUrl={'/joyful-days'}
        />
      ) : (
        <OfferStripHeader showHeader={true} sticky={true} />
      )}
      {renderContent() ? (
        renderContent()
      ) : (
        <>
          <GlobalStyle />
          <SkeletonBox height="100vh" width="100vw" />
        </>
      )}

      <WebTab onTabChange={setActiveTab} />

      <KwikPassSsoTooltip
        setShowSsoTooltip={setShowSsoTooltip}
        showSsoTooltip={showSsoTooltip}
        openLoginPopUp={openLoginPopUp}
      />

      <NewFooter
        heading={seoFootnoteData?.heading}
        content={seoFootnoteData?.htmlText}
        categoryData={categoryData}
      />
    </>
  );
}

export default Brand;
